import PropTypes from 'prop-types'
import React from 'react'

import { CHAR_LOGO_BG_COLORS } from '../../config'

const colors = CHAR_LOGO_BG_COLORS

const styles = (str) => ({
  color: 'white',
  backgroundColor: colors[hash(str, colors.length)]
})

/**
 * Creates a simple hash from given string by summing up the character codes
 * and fitting the result into the desired range.
 *
 * @param str The input string
 * @param boundary Integer, e.g. array length
 * @returns {number} `0` for empty string or `null`, otherwise an integer `x`
 * in range `0 <= x < boundary`
 */
export const hash = (str, boundary) => {
  if (!str) return 0
  return Math.abs(
    str.split('')
      .map(s => s.charCodeAt(0))
      .reduce((sum, value) => sum + value)
  ) % boundary
}

export const CharLogo = ({ name }) => (
  <div role='img' className='char-logo text-center' style={styles(name)}>
    {name.charAt(0).toUpperCase()}
  </div>
)

CharLogo.propTypes = {
  name: PropTypes.string.isRequired
}

export default CharLogo
